import { Div, Collection, Line } from "@tblabs/truffle";
import { Order } from "../../Models/Order";
import { OrdersManager } from "../../Services/Storage/OrdersManager";
import { AgentToDoView } from "./AgentToDoView";
import { BigHeader } from "../../Components/Utils/SmallHeader";
import { AgentsProvider } from "../../Services/Agents/AgentsProvider";
import { Page } from "../Page";
import { OrdersFolders } from "../../Models/OrdersFolders";
import { InfoBox } from "../../Components/InfoBox";


export class AgentOrdersViewPage extends Page
{
    constructor(
        private _manager: OrdersManager, 
        private _agents: AgentsProvider,
        private agentId: string)
    {
        super(`Zadania agenta ${agentId}`);

        this.Content(async (body) =>
        {
            const agent = this._agents.Get(this.agentId);
            if (!agent)
            {
                body.Append(new InfoBox("Agent nie znaleziony", "Agent o ID ${this.agentId} nie istnieje"));
                return;
            }

            const orders: Order[] = await this._manager.FetchAll(OrdersFolders.Open);
            // orders.forEach(x => x.SelfSetup());

            const ordersCollection = new Collection(orders);

            body.Append(
                new BigHeader(`Zadania agenta ${agent.Name}`),
                new Div().ClearBoth(),
                new Line(),
                new AgentToDoView(this._manager, this._agents, ordersCollection, this.agentId)
            );
        });
    }
}
